import { fetchAnnouncements, fetchAnnouncement, deleteAnnouncement, create } from '@/services/announcement/announcementService'
import Vue from 'vue' 
const state = {
  announcements: [],
  announcement: {},
  isAnnouncementLoading: false,
  isDeletingAnnouncement: false,
}

const getters = {
  announcements: (state) => state.announcements,
  announcement: (state) => state.announcement,
  isAnnouncementLoading: (state) => state.isAnnouncementLoading,
  isDeletingAnnouncement: (state) => state.isDeletingAnnouncement,
}

const actions = {
    async fetchAnnouncements({ commit, dispatch, rootState }) {
        commit('setIsLoading', true)
        const defaultParams = {
          size: rootState.paginate.itemsPerPage,
          page: rootState.paginate.currentPage - 1,
        }
        const params = { ...defaultParams, ...rootState.filters.filters }
        try {
          const { data } = await fetchAnnouncements(params)
          const { result, total } = await data
          commit('setAnnouncements', result)
          commit('setTotalPages', total)
        } catch ({ data }) {
          dispatch('showErrorMessage', data.message)
        } finally {
          commit('setIsLoading', false)
        }
    },
    async fetchAnnouncement({ commit, dispatch }, id) {
      commit('setIsAnnouncementLoading', true)
      try {
        const { data } = await fetchAnnouncement(id)
        commit('setAnnouncement', data)
      } catch ({ data }) {
        dispatch('showErrorMessage', data.message)
      } finally {
        commit('setIsAnnouncementLoading', false)
      }
    },
    async deleteAnnouncement({ commit, dispatch }, id) {
      commit('setIsDeletingAnnouncement', true)
      
      try {
        await deleteAnnouncement(id)
        dispatch('showSuccessMessage', Vue.i18n.translate('announcement.label.messages.successDelete'))
        dispatch('fetchAnnouncements')
        commit('closeAllModals')
      } catch ({ data }) {
        dispatch('showErrorMessage', data.message)
      } finally {
        commit('setIsDeletingAnnouncement', false)
      }
    },
    async createAnnouncement(state, body) {
      return create(body)
    },
}

const mutations = {
    setAnnouncements: (state, announcements) => {
        state.announcements = announcements
    },
    setAnnouncement: (state, announcement) => {
      state.announcement = announcement
    },

    setIsAnnouncementLoading: (state, status) => {
      state.isAnnouncementLoading = status
    },

    setIsDeletingAnnouncement: (state, status) => {
      state.isDeletingAnnouncement = status
    }
}

export default {
  state,
  mutations,
  actions,
  getters,
}
